import { atom } from 'recoil';

import {
  currentReportYearOption,
  initialReportMarketOption,
  initialReportMonthOption,
  initialReportPeriodDates,
  initialReportPeriodOption,
  initialReportTypeOption,
} from './constants';
import { ReportFitlerParams } from './types';

export const reportTypeOptionState = atom({
  key: 'reportTypeOptionState',
  default: initialReportTypeOption,
});

export const reportMarketOptionState = atom({
  key: 'reportMarketOptionState',
  default: initialReportMarketOption,
});

export const reportPeriodOptionState = atom({
  key: 'reportPeriodOptionState',
  default: initialReportPeriodOption,
});

export const reportPeriodDatesState = atom({
  key: 'reportPeriodDatesState',
  default: initialReportPeriodDates,
});

export const reportYearOptionState = atom({
  key: 'reportYearOptionState',
  default: '',
});

export const reportPeriodYearOptionState = atom({
  key: 'reportPeriodYearOptionState',
  default: '',
});

export const reportYearBrokerageOptionState = atom({
  key: 'reportYearBrokerageOptionState',
  default: currentReportYearOption,
});

export const reportMonthSelectedOptionsState = atom({
  key: 'reportMonthSelectedOptionsState',
  default: initialReportMonthOption,
});

export const reportComplementaryTitleOptionsState = atom({
  key: 'reportComplementaryTitleOptionsState',
  default: '',
});

export const reportFilterParamsState = atom({
  key: 'reportFilterParamsState',
  default: {
    reportMarketOption: initialReportMarketOption,
    reportMonthSelectedOptions: initialReportMonthOption,
    reportYearOption: currentReportYearOption,
    reportPeriodDates: initialReportPeriodDates,
  } as ReportFitlerParams,
});
